import { BASVURU_ANA_DURUM_LISTESI } from "../constants/requestUrls";
import { postRequest } from "../request";

const basvuruAnaDurumLists = (props) => {
    let data ={};
    if(props !== undefined)
    data = JSON.stringify(props);

    return postRequest({url:BASVURU_ANA_DURUM_LISTESI,data});
}

export default basvuruAnaDurumLists;